var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.48485 0.5 0 4.98485 0 10.5C0 16.0152 4.48485 20.5 10 20.5C15.5152 20.5 20 16.0152 20 10.5C20 4.98485 15.5152 0.5 10 0.5ZM10 19.2879C5.15152 19.2879 1.21212 15.3485 1.21212 10.5C1.21212 5.65152 5.15152 1.71212 10 1.71212C14.8485 1.71212 18.7879 5.65152 18.7879 10.5C18.7879 15.3485 14.8485 19.2879 10 19.2879Z",
    fill: "#146C43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0304 7.86369L8.4243 13.4395C8.394 13.4698 8.33339 13.4698 8.30309 13.4395L5.96976 11.1061C5.72733 10.8637 5.3637 10.8637 5.12127 11.1061C4.87885 11.3485 4.87885 11.7122 5.12127 11.9546L7.4546 14.2879C7.69703 14.5304 8.03036 14.6819 8.36369 14.6819C8.72733 14.6819 9.03036 14.5607 9.27279 14.2879L14.8788 8.68188C15.1213 8.43945 15.1213 8.07582 14.8788 7.83339C14.6364 7.59097 14.2728 7.62127 14.0304 7.86369Z",
    fill: "#146C43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.884b32c3bbc83281743a0d8b66ada375.svg";
export { ForwardRef as ReactComponent };